(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kion-motion-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kion-motion-showcase')) {
    customElements.define('kion-motion-showcase', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.items = Array.from(this.querySelectorAll('.kion-showcase__item'));
        if (!this.items.length) return;
        this.index = 0;
        this.stage = this.querySelector('.kion-showcase__stage');
        this.querySelector('.kion-showcase__controls').hidden = this.items.length < 2;
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => this.select(this.index + Number(button.dataset.direction)), options));
        this.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const focusedItem = event.target.closest('.kion-showcase__item');
            this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1));
            if (focusedItem) this.items[this.index].focus({ preventScroll: true });
          }
        }, options);
        this.stage.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.start = { x: event.clientX, y: event.clientY };
          this.dragged = false;
        }, options);
        this.stage.addEventListener('pointerup', event => {
          if (!this.start) return;
          const dx = event.clientX - this.start.x;
          const dy = event.clientY - this.start.y;
          this.start = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            this.dragged = true;
            this.select(this.index + (dx < 0 ? 1 : -1));
          }
        }, options);
        this.stage.addEventListener('pointercancel', () => { this.start = null; }, options);
        this.stage.addEventListener('dragstart', event => event.preventDefault(), options);
        this.stage.addEventListener('click', event => {
          const item = event.target.closest('.kion-showcase__item');
          if (!item) return;
          if (this.dragged) { event.preventDefault(); this.dragged = false; return; }
          const next = this.items.indexOf(item);
          if (next !== this.index) { event.preventDefault(); this.select(next); }
        }, options);
        this.observer?.disconnect();
        this.observer = new ResizeObserver(() => this.paint());
        this.observer.observe(this);
        this.paint();
        this.classList.add('is-ready');
      }
      select(index) {
        this.index = (index + this.items.length) % this.items.length;
        this.paint();
        this.querySelector('[aria-live]').textContent = this.items[this.index].dataset.title;
      }
      paint() {
        const count = this.items.length;
        const mobile = this.clientWidth < 750;
        const spacing = mobile ? this.clientWidth * .43 : Math.min(this.clientWidth * .235, 270);
        this.items.forEach((item, index) => {
          let offset = (index - this.index + count) % count;
          if (offset > count / 2) offset -= count;
          const distance = Math.abs(offset);
          item.style.setProperty('--ks-x', `${offset * spacing}px`);
          item.style.setProperty('--ks-scale', distance === 0 ? 1 : distance === 1 ? .78 : .59);
          item.style.setProperty('--ks-opacity', distance > 2 ? 0 : distance === 0 ? 1 : distance === 1 ? .7 : .35);
          item.style.setProperty('--ks-z', 5 - distance);
          item.toggleAttribute('data-active', distance === 0);
          item.tabIndex = distance === 0 ? 0 : -1;
          item.setAttribute('aria-hidden', distance === 0 ? 'false' : 'true');
          item.style.pointerEvents = distance > 2 ? 'none' : 'auto';
        });
        this.querySelector('.kion-showcase__count').textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(count).padStart(2, '0')}`;
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
